import { getReqMessage } from '../../../../utils/formValidation/errorMessageFunctions';

export const initialErrorState = {};

export const validate = (newEntry) => {
    let newErrors = {};

    if (newEntry.rejectionReasonIds.length < 1) {
        newErrors = {
            ...newErrors,
            rejectionReasonIds: { error: true, message: getReqMessage('Rejection Reason') }
        };
    }

    return newErrors;
};
